import { atom } from 'recoil';

export const ModeVehicleState = atom({
    key: 'ModeVehicleState', 
    default: null, 
});